import React from "react";
import { CustomAdminTable, CustomPageLayout } from "../../Component/customComponents";

// There is no API for this page yet, so it shows the columns with an empty state (as before).
const columns = [
  { key: "firstName", header: "First Name" },
  { key: "lastName", header: "Last Name" },
  { key: "mobileNo", header: "Mobile No" },
  { key: "state", header: "State" },
  { key: "city", header: "City" },
  { key: "admissionDate", header: "Admission Date" },
  { key: "payment", header: "Payment", align: "right" },
];

function AdmissionDetails() {
  return (
    <CustomPageLayout title="ADMISSION DETAILS">
      <CustomAdminTable
        id="admission-details-table"
        title="Admissions"
        columns={columns}
        data={[]}
        enableSerialNumber
        serialHeader="S.No"
        emptyTitle="No admission data yet"
        emptyDescription="This report isn't connected to the server yet."
      />
    </CustomPageLayout>
  );
}

export default AdmissionDetails;
